import { CoursePageContentResponseModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import { useGetApiV1MemberBookingsSuspense } from '@shared/integrations/taf-api/v1/features/member/member.ts';
import Alerts from '@shared/components/Alerts.tsx';
import BookedCoursesCard from '@my-pages/features/courses/components/BookedCoursesCard.tsx';
import CompletedCoursesCard from '@my-pages/features/courses/components/CompletedCoursesCard.tsx';

interface ICoursesPage {
    content: CoursePageContentResponseModel;
}

//@ts-ignore
const CoursesPage = ({ content }: ICoursesPage) => {
    const { data } = useGetApiV1MemberBookingsSuspense();
    return (
        <>
            <h1 className='page-title'>Kurser</h1>
            <div className='slide-up-fade-in'>
                {content?.properties?.importantMessages && (
                    <div className='mb-4'>
                        <Alerts alerts={content?.properties?.importantMessages} />
                    </div>
                )}
                <BookedCoursesCard bookings={data} />
                <CompletedCoursesCard bookings={data} />
            </div>
        </>
    );
};

export default CoursesPage;
